// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aS2B7IIz-CoaELjJLx6JMw\\=\\={max-width:400px}", "",{"version":3,"sources":["webpack://./resources/client/src/app/modules/lending/components/sections/header/index.module.scss"],"names":[],"mappings":"AAAA,4BAAK,eAAe","sourcesContent":[".img{max-width:400px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": "aS2B7IIz-CoaELjJLx6JMw=="
};
export default ___CSS_LOADER_EXPORT___;
